import React, { useState } from 'react';
import { cache } from '../../graphql/cache';
import { useQuery, useLazyQuery, useMutation } from '@apollo/client';
import {
  GET_CUENTO_ID,
  GET_CUENTOS,
  SEARCH_CUENTOS,
  REMOVE_CUENTO,
} from '../../graphql/actions/cuento';
// nodejs library that concatenates classes
//import classNames from 'classnames';
// react components for routing our app without refresh
import { withRouter } from 'react-router-dom';
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';
import Icon from '@material-ui/core/Icon';
// @material-ui/icons
import Subject from '@material-ui/icons/Subject';
import Delete from '@material-ui/icons/Delete';
// core components
import GridContainer from '../../components/UI/Grid/GridContainer';
import GridItem from '../../components/UI/Grid/GridItem';
import Card from '../../components/UI/Card/Card';
import CardBody from '../../components/UI/Card/CardBody';
import Button from '../../components/UI/CustomButtons/Button';
import Spinner from '../../components/UI/Spinner/Spinner';
import Notification from '../../components/Notification/Notification';
import Order from '../Order/Order';
import Filter from '../Filter/Filter';
import Limit from '../Limit/Limit';
import Paginate from '../Paginate/Paginate';
import Total from '../Total/Total';
import ButtonAdd from '../ButtonAdd/ButtonAdd';
import CuentoDel from './CuentoDel';

import sectionDataStyle from '../../assets/jss/coscef/views/articuloSections/sectionDataStyle';

const useStyles = makeStyles(sectionDataStyle);

const CuentoData = (props) => {
  const classes = useStyles();
  const [numCuentos, setNumCuentos] = useState(9);
  const [field, setField] = useState('createdAt');
  const [order, setOrder] = useState('ASC');
  const [search, setSearch] = useState('');
  const [eliminarCuentoModal, setEliminarCuentoModal] = useState(false);

  const eliminarShowModalHandler = (id) => {
    cache.writeQuery({
      query: GET_CUENTO_ID,
      data: { getCuentoId: id },
    });
    setEliminarCuentoModal(true);
  };

  const eliminarCloseModalHandler = () => {
    setEliminarCuentoModal(false);
  };

  const closeModalHandler = (data) => {
    //console.log(data);
    if (data.removeCuento) setEliminarCuentoModal(false);
    else console.log('Error eliminando cuento.');
  };

  const updateCacheDel = (cache, id) => {
    const { getCuentos } = cache.readQuery({
      query: GET_CUENTOS,
      variables: {
        paginate: {
          numCuentos: numCuentos,
          cursor: '',
          sortBy: { field: field, order: order },
        },
      },
    });

    const nuevoCuentos = getCuentos.cuentos.filter(
      (cuento) => cuento.id !== id
    );

    if (getCuentos && nuevoCuentos) {
      cache.writeQuery({
        query: GET_CUENTOS,
        variables: {
          paginate: {
            numCuentos: numCuentos,
            cursor: '',
            sortBy: { field: field, order: order },
          },
        },
        data: {
          getCuentos: {
            cuentos: nuevoCuentos,
          },
        },
      });
    }
  };

  const {
    loading: loadingCuentos,
    error: errorCuentos,
    data: dataCuentos,
    fetchMore,
  } = useQuery(GET_CUENTOS, {
    variables: {
      paginate: {
        numCuentos: numCuentos,
        cursor: '',
        sortBy: { field: field, order: order },
      },
    },
    errorPolicy: 'all',
  });

  const [executeSearch, { loading: loadingSearch, data: dataSearch }] =
    useLazyQuery(SEARCH_CUENTOS, {
      errorPolicy: 'all',
    });

  const [
    eliminarCuento,
    { loading: loadingRemove, error: errorRemove, data: dataRemove },
  ] = useMutation(REMOVE_CUENTO, {
    errorPolicy: 'all',
    update: updateCacheDel,
    onCompleted: (data) => closeModalHandler(data),
  });

  const onSearchHandler = (event) => {
    event.preventDefault();
    executeSearch({
      variables: {
        paginate: {
          numCuentos: numCuentos,
          cursor: '',
          query: search,
          sortBy: { field: field, order: order },
        },
      },
    });
  };

  const removeCuentoHandler = (id) => {
    eliminarCuento({
      variables: {
        input: {
          id: id,
        },
      },
    });
  };

  const numCuentosChangedHandler = (event) => {
    if (event.target.name === 'numComponentes')
      setNumCuentos(event.target.value);
  };

  const fieldChangedHandler = (event) => {
    if (event.target.name === 'field') setField(event.target.value);
  };

  const orderChangedHandler = (event) => {
    if (event.target.name === 'order') setOrder(event.target.value);
  };

  const searchChangedHandler = (event) => {
    if (event.target.name === 'search') setSearch(event.target.value);
  };

  const onPaginationHandler = (cursor) => {
    fetchMore({
      variables: {
        paginate: {
          numCuentos: numCuentos,
          cursor: cursor,
          sortBy: { field: field, order: order },
        },
      },
      updateQuery: (prev, { fetchMoreResult }) => {
        if (!fetchMoreResult) return prev;
        fetchMoreResult.getCuentos.cuentos = [
          ...prev.getCuentos.cuentos,
          ...fetchMoreResult.getCuentos.cuentos,
        ];
        return fetchMoreResult;
      },
    });
  };

  let showNotification = null;
  let seccionTitulo = null;
  let seccionOrderFilter = null;
  let seccionCardCuento = null;
  let seccionBotonAdd = null;
  let seccionLimitPagination = null;
  let seccionTotal = null;
  let removeModal = (
    <CuentoDel
      show={eliminarCuentoModal}
      close={eliminarCloseModalHandler}
      removeCuento={removeCuentoHandler}
    />
  );

  if (loadingCuentos) {
    seccionTitulo = (
      <div className={classes.section}>
        <GridContainer justify='center'>
          <GridItem xs={12} sm={8} md={8}>
            <Spinner color='gray' />
          </GridItem>
        </GridContainer>
      </div>
    );
  }
  if (loadingRemove) removeModal = <Spinner color='gray' />;
  if (loadingSearch) {
    seccionOrderFilter = (
      <div id='orderandfilter' className={classes.marginBottom20}>
        <GridContainer>
          <GridItem xs={12} sm={6} md={6}>
            <Order />
          </GridItem>
          <GridItem xs={12} sm={6} md={6}>
            <Spinner color='gray' />
          </GridItem>
        </GridContainer>
      </div>
    );
  }

  if (errorCuentos) {
    seccionTitulo = (
      <div className={classes.section}>
        <GridContainer justify='center'>
          <GridItem xs={12} sm={8} md={8}>
            <h2 className={classes.title}>
              Error al buscar los cuentos en el servidor.
            </h2>
          </GridItem>
        </GridContainer>
      </div>
    );

    seccionOrderFilter = null;
    seccionCardCuento = null;
    seccionBotonAdd = null;
    seccionLimitPagination = null;
    seccionTotal = null;

    showNotification = errorCuentos.graphQLErrors.map(
      ({ message, status, code }) => (
        <Notification
          key={code}
          mostrar={errorCuentos ? true : false}
          msg={message}
          stt={status}
        />
      )
    );
  }
  if (errorRemove) {
    showNotification = errorRemove.graphQLErrors.map(
      ({ message, status, code }) => (
        <Notification
          key={code}
          mostrar={errorRemove ? true : false}
          msg={message}
          stt={status}
        />
      )
    );
  }

  if (dataCuentos && dataCuentos.getCuentos) {
    const { getCuentos } = dataCuentos;
    //console.log(getCuentos);
    if (getCuentos.cuentos.length === 0) {
      seccionTitulo = (
        <div className={classes.section}>
          <GridContainer justify='center'>
            <GridItem xs={12} sm={8} md={8}>
              <h2 className={classes.title}>
                No se encontraron cuentos, inténtelo más tarde.
              </h2>
            </GridItem>
          </GridContainer>
        </div>
      );

      seccionOrderFilter = null;
      seccionCardCuento = null;

      seccionBotonAdd = props.isAuth ? (
        <div id='buttonadd'>
          <ButtonAdd nombreComponente={'cuento'} />
        </div>
      ) : null;

      seccionLimitPagination = null;
      seccionTotal = null;
    } else {
      seccionTitulo = (
        <div className={classes.section}>
          <GridContainer justify='center'>
            <GridItem xs={12} sm={8} md={8}>
              <h2 className={classes.title}>Cuentos</h2>
            </GridItem>
          </GridContainer>
        </div>
      );

      seccionOrderFilter = (
        <div id='orderandfilter' className={classes.marginBottom20}>
          <GridContainer>
            <GridItem xs={12} sm={6} md={6}>
              <Order
                orderBy={order}
                orderByChange={orderChangedHandler}
                fieldBy={field}
                fieldByChange={fieldChangedHandler}
              />
            </GridItem>
            <GridItem xs={12} sm={6} md={6}>
              <Filter
                nombreComponente={'cuento'}
                searchChange={searchChangedHandler}
                runSearch={onSearchHandler}
              />
            </GridItem>
          </GridContainer>
        </div>
      );

      seccionCardCuento = (
        <GridContainer>
          {getCuentos.cuentos.map((cuento) => (
            <GridItem xs={12} sm={4} md={4} key={cuento.node._id}>
              <Card color='dark' key={cuento.node._id}>
                <CardBody color>
                  <h4
                    className={
                      classes.cardTitleWhite + ' ' + classes.textCenter
                    }
                  >
                    {cuento.node.titulo}
                  </h4>
                  <br />
                  <p
                    className={
                      classes.cardDescriptionWhite + ' ' + classes.textCenter
                    }
                  >
                    {cuento.node.resumen + ' ...'}
                  </p>
                  {props.isAuth ? (
                    <div className={classes.textCenter}>
                      <Button
                        round
                        justIcon
                        color='white'
                        onClick={(e) => {
                          e.preventDefault();
                          props.history.push('/cuento/' + cuento.node._id);
                        }}
                      >
                        <Subject />
                      </Button>
                      <Button
                        round
                        justIcon
                        color='white'
                        onClick={(e) => {
                          e.preventDefault();
                          props.history.push(
                            '/editar-cuento/' + cuento.node._id
                          );
                        }}
                      >
                        <Icon>mode_edit</Icon>
                      </Button>
                      <Button
                        round
                        justIcon
                        color='white'
                        onClick={() =>
                          eliminarShowModalHandler(cuento.node._id)
                        }
                      >
                        <Delete />
                      </Button>
                    </div>
                  ) : (
                    <div
                      className={
                        classes.stats + ' ' + classes.justifyContentCenter
                      }
                    >
                      <Button
                        color='white'
                        round
                        onClick={(e) => {
                          e.preventDefault();
                          props.history.push('/cuento/' + cuento.node._id);
                        }}
                      >
                        Leer Cuento
                      </Button>
                    </div>
                  )}
                </CardBody>
              </Card>
            </GridItem>
          ))}
        </GridContainer>
      );

      seccionBotonAdd = props.isAuth ? (
        <div id='buttonadd'>
          <ButtonAdd nombreComponente={'cuento'} />
        </div>
      ) : null;

      seccionLimitPagination = (
        <div id='limitandpagination'>
          <GridContainer>
            <GridItem xs={12} sm={6} md={6}>
              <Limit
                numdComponentes={numCuentos}
                numdComponentesChange={numCuentosChangedHandler}
                nombreComponente={'Cuentos'}
              />
            </GridItem>
            <GridItem xs={12} sm={6} md={6}>
              <Paginate
                cursorInicial={getCuentos.pageInfo.startCursor}
                cursorFinal={getCuentos.pageInfo.endCursor}
                tienePaginaSiguiente={getCuentos.pageInfo.hasNextPage}
                paginaSiguiente={onPaginationHandler}
              />
            </GridItem>
          </GridContainer>
        </div>
      );

      seccionTotal = (
        <div id='total' className={classes.marginTop60}>
          <Total
            countArticulos={getCuentos.totalCount}
            nombreComponente={'Cuentos'}
          />
        </div>
      );
    }
  }

  if (dataSearch && dataSearch.searchCuentos) {
    const { searchCuentos } = dataSearch;

    if (searchCuentos.cuentos.length === 0) {
      seccionTitulo = null;

      seccionOrderFilter = (
        <div id='orderandfilter' className={classes.marginBottom20}>
          <GridContainer>
            <GridItem xs={12} sm={6} md={6}></GridItem>
            <GridItem xs={12} sm={6} md={6}>
              <Filter
                nombreComponente={'cuento'}
                searchChange={searchChangedHandler}
                runSearch={onSearchHandler}
              />
            </GridItem>
          </GridContainer>
        </div>
      );

      seccionCardCuento = (
        <div className={classes.section}>
          <GridContainer justify='center'>
            <GridItem xs={12} sm={8} md={8}>
              <h2 className={classes.title}>
                No se encontraron cuentos en la busqueda.
              </h2>
            </GridItem>
          </GridContainer>
        </div>
      );

      seccionBotonAdd = null;

      seccionLimitPagination = null;
      seccionTotal = null;
    } else {
      seccionOrderFilter = (
        <div id='orderandfilter' className={classes.marginBottom20}>
          <GridContainer>
            <GridItem xs={12} sm={6} md={6}>
              <Order
                orderBy={order}
                orderByChange={orderChangedHandler}
                fieldBy={field}
                fieldByChange={fieldChangedHandler}
              />
            </GridItem>
            <GridItem xs={12} sm={6} md={6}>
              <Filter
                nombreComponente={'cuento'}
                searchChange={searchChangedHandler}
                runSearch={onSearchHandler}
              />
            </GridItem>
          </GridContainer>
        </div>
      );

      seccionCardCuento = (
        <GridContainer>
          {searchCuentos.cuentos.map((cuento) => (
            <GridItem xs={12} sm={4} md={4} key={cuento.node._id}>
              <Card color='dark' key={cuento.node._id}>
                <CardBody color>
                  <h4
                    className={
                      classes.cardTitleWhite + ' ' + classes.textCenter
                    }
                  >
                    {cuento.node.titulo}
                  </h4>
                  <br />
                  <p
                    className={
                      classes.cardDescriptionWhite + ' ' + classes.textCenter
                    }
                  >
                    {cuento.node.resumen + ' ...'}
                  </p>
                  {props.isAuth ? (
                    <div className={classes.textCenter}>
                      <Button
                        round
                        justIcon
                        color='white'
                        onClick={(e) => {
                          e.preventDefault();
                          props.history.push('/cuento/' + cuento.node._id);
                        }}
                      >
                        <Subject />
                      </Button>
                      <Button
                        round
                        justIcon
                        color='white'
                        onClick={(e) => {
                          e.preventDefault();
                          props.history.push(
                            '/editar-cuento/' + cuento.node._id
                          );
                        }}
                      >
                        <Icon>mode_edit</Icon>
                      </Button>
                      <Button
                        round
                        justIcon
                        color='white'
                        onClick={() =>
                          eliminarShowModalHandler(cuento.node._id)
                        }
                      >
                        <Delete />
                      </Button>
                    </div>
                  ) : (
                    <div
                      className={
                        classes.stats + ' ' + classes.justifyContentCenter
                      }
                    >
                      <Button
                        color='white'
                        round
                        onClick={(e) => {
                          e.preventDefault();
                          props.history.push('/cuento/' + cuento.node._id);
                        }}
                      >
                        Leer Cuento
                      </Button>
                    </div>
                  )}
                </CardBody>
              </Card>
            </GridItem>
          ))}
        </GridContainer>
      );

      seccionBotonAdd = props.isAuth ? (
        <div id='buttonadd'>
          <ButtonAdd nombreComponente={'cuento'} />
        </div>
      ) : null;

      seccionLimitPagination = (
        <div id='limitandpagination'>
          <GridContainer>
            <GridItem xs={12} sm={6} md={6}>
              <Limit
                numdComponentes={numCuentos}
                numdComponentesChange={numCuentosChangedHandler}
                nombreComponente={'Cuentos'}
              />
            </GridItem>
            <GridItem xs={12} sm={6} md={6}>
              <Paginate
                cursorInicial={searchCuentos.pageInfo.startCursor}
                cursorFinal={searchCuentos.pageInfo.endCursor}
                tienePaginaSiguiente={searchCuentos.pageInfo.hasNextPage}
                paginaSiguiente={onPaginationHandler}
              />
            </GridItem>
          </GridContainer>
        </div>
      );

      seccionTotal = (
        <div id='total' className={classes.marginTop60}>
          <Total
            countArticulos={searchCuentos.totalCount}
            nombreComponente={'Cuentos'}
          />
        </div>
      );
    }
  }

  if (dataRemove && dataRemove.removeCuento) {
    const { removeCuento } = dataRemove;
    if (removeCuento.success && removeCuento.code === '200') {
      showNotification = (
        <Notification
          key={removeCuento.code}
          mostrar={removeCuento.success ? true : false}
          msg={removeCuento.message}
          stt={removeCuento.success}
        />
      );
    }
  }

  return (
    <div className={classes.sections}>
      <div className={classes.sectionWhite}>
        <div>
          <div className={classes.container}>
            {seccionTitulo}
            <div className={classes.marginTop35}>
              {removeModal}
              {seccionOrderFilter}
              {seccionCardCuento}
              {seccionBotonAdd}
              {seccionLimitPagination}
              {seccionTotal}
            </div>
          </div>
          {showNotification}
        </div>
      </div>
    </div>
  );
};

export default withRouter(CuentoData);
